import { Bell } from 'lucide-react';
import { type ReactElement } from 'react';
import type { Getter, Row, Table } from '@tanstack/react-table';

import { AlarmActivationSeverity } from '@crossnokaye/typescript-sdk/models/components/alarmactivation';
import { DataTableMeta, Gutter, Icon } from '@crossnokaye/ux-common';

import { getAlarmIconConfig } from './helpers';

/**
 *
 * @param param0 Cell context.
 * @returns ReactElement.
 */
export const SeverityCell = <TData extends { status: 'Active' | 'Inactive' }>({
  getValue,
  row,
  table,
}: {
  getValue: Getter<AlarmActivationSeverity>;
  row: Row<TData>;
  table: Table<TData>;
}): ReactElement => {
  const severity = getValue() as AlarmActivationSeverity;
  const isMobile = (table.options.meta as DataTableMeta<TData>)?.isMobile;

  const { color, background, isPulsing } = getAlarmIconConfig(
    severity,
    row.original.status === 'Active'
  );

  return (
    <Gutter size="responsive">
      <div className={'flex flex-row items-center gap-1'}>
        <Icon
          icon={Bell}
          color={color}
          data-testid={'icon'}
          size="md"
          backgroundColor={background}
          variant="rounded"
          isPulsing={isPulsing}
        />
        {!isMobile && (
          <span className={'text-sm truncate px-1'}>
            {severity.charAt(0).toUpperCase() + severity.slice(1)}
          </span>
        )}
      </div>
    </Gutter>
  );
};
